import { useEffect, useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { Modal, ModalContent, ModalTitle, useMuiModal } from "./modal";
import { Trans, useTranslation } from "react-i18next";
import { useRemovePayment } from "@/hooks/use-remove-payment";
import { getPaymentFromSessionStorage } from "@/features/payment/utils";
import { resetKiosk } from "@/lib/utils";
import { useAudioSlot } from "@/features/audio/kiosk-audio";

export function InvactivityModal() {
  useAudioSlot("modal.inactivity");
  useTranslation();
  const { closeAllModals, closeModal } = useMuiModal();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(15);
  const removePayment = useRemovePayment();

  const onTimeout = async () => {
    const payment = getPaymentFromSessionStorage();
    if (payment) {
      try {
        await removePayment.mutateAsync({
          key: payment.kioskPaymentNonceKey,
          cause: "inactivity",
        });
      } catch (e) {
        console.error(e);
      }
    }
    await resetKiosk({ endReason: "inactivity" });
    navigate({ to: "/start-screen", reloadDocument: true });
    closeAllModals();
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onTimeout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Modal onClick={() => closeModal()}>
      <ModalTitle>
        <Trans>Inaktív voltál</Trans>
      </ModalTitle>
      <ModalContent>
        <p className="text-sky-600 text-lg mb-8 font-medium">
          <Trans>Kérjük érintsd meg a képernyőt</Trans>
        </p>

        {/* Countdown box */}
        <div className="inline-block mb-8">
          <div className="w-20 h-20 border-3 border-orange-500 rounded-lg flex items-center justify-center bg-white">
            <span className="text-3xl font-bold text-orange-500">
              {countdown}
            </span>
          </div>
        </div>

        <p className="text-sky-600 text-base leading-relaxed">
          <Trans>
            másodpercen belül, máskülönben a rendszer automatikusan kiléptet.
          </Trans>
        </p>
      </ModalContent>
    </Modal>
  );
}
